<template>
  <time v-if="timeStamp" :datetime="isoDate" class="date">{{ date }}</time>
</template>

<script>
import { decorators } from '@sohohouse/platform-resources'

const { DateTime } = decorators.shared

export default {
  name: 'DateFormatter',
  props: {
    timeStamp: {
      type: [Object, String],
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'abrDate'
    },
    timezone: {
      type: String,
      required: false
    }
  },
  computed: {
    date () {
      const dateTime = new DateTime(this.timeStamp)
      if (this.timezone) {
        dateTime.setTimezone(this.timezone)
      }
      return this.$d(dateTime.withOffset.epoch, this.type)
    },
    isoDate () {
      return new DateTime(this.timeStamp).isoString
    }
  }
}
</script>
